import styledComponents from 'styled-components'

export const HeroSection = styledComponents.section.attrs({
  className: 'hero',
})``
export const HeroBody = styledComponents.section.attrs({
  className: 'hero-body',
})``



// WEBPACK FOOTER //
// ./src/components/views/layouts/Hero.js